import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from "vue";
import { LostFoundStatusCode, LostFoundTypeCode } from "@/types";
import { ILostFound } from "@/domain/entities/bbs/lostFound/lostFound.types";


const __default__ = {
  name: "LostFoundRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lostFound: {
    type: Object as PropType<ILostFound>,
    required: true,
  },
},
  emits: ["onClickRow"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const lostFoundStatusCodeMap: Record<string, string> = {
  [LostFoundStatusCode.STORE]: "store",
  [LostFoundStatusCode.RECOVE]: "recover",
  [LostFoundStatusCode.DISCAR]: "discard",
};

const typeText = computed(() =>
  props.lostFound.type === LostFoundTypeCode.Lost ? "분실" : "습득"
);

const lostFoundDateTime = computed(() =>
  props.lostFound.type === LostFoundTypeCode.Lost
    ? props.lostFound.lostTs
    : props.lostFound.foundTs
);

const lostFoundLineName = computed(() => {
  const { type, lineRouteName, lineName } = props.lostFound;
  return type === LostFoundTypeCode.Lost
    ? lineName ?? lineRouteName
    : lineRouteName;
});

const emitOnClickRow = () => {
  emit("onClickRow", props.lostFound);
};

const __returned__ = { props, emit, lostFoundStatusCodeMap, typeText, lostFoundDateTime, lostFoundLineName, emitOnClickRow }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})